import * as React from 'react';
import { EMPTY_ERROR_ARRAY } from '../../constants';
export const usePollInputErrors = () => {
    const [pollInputErrors, setPollInputErrors] = React.useState(EMPTY_ERROR_ARRAY);
    const togglePollInputError = (index, toggle) => {
        if (index > 4)
            return;
        const newInputErrors = [...pollInputErrors];
        newInputErrors[index] = toggle;
        setPollInputErrors(newInputErrors);
    };
    return {
        hasInputErrors: !!pollInputErrors.filter((error) => error).length,
        pollInputErrors,
        togglePollInputError,
    };
};
//# sourceMappingURL=use-poll-option-errors.js.map